import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';
import type { IncidentAlertToneProps } from '.';

export const Wrapper = styled.div`
  --_text-size: ${(props) => props.theme.font.size.small};
  --_text-line-height: 1.5;
  --_icon-size: ${size(3)};

  position: sticky;
  top: 0;
  margin-bottom: var(--main-gutter);
  z-index: ${(props) => props.theme.zindex.incidentAlert};
`;

interface BarProps {
  $tone?: IncidentAlertToneProps;
}

export const Bar = styled.div.attrs(() => ({
  role: 'alert',
}))<BarProps>`
  --_spacing-block: ${size(2)};
  --_spacing-inline: ${size(3)};

  ${(props) => props.theme.breakpoint.Md} {
    --_spacing-block: ${size(3)};
    --_spacing-inline: ${size(4)};
  }

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--_spacing-block);
  padding: var(--_spacing-block) var(--_spacing-inline);
  border-radius: ${size(2)};
  background-color: var(--_bg, var(--c-semantic-neutral-300));
  color: var(--_fg, var(--c-text-main));
  border: 1px solid var(--_accent_fg, var(--c-semantic-neutral-700));

  ${({ $tone }) =>
    $tone === 'error'
      ? css`
          --_bg: var(--c-semantic-error-100);
          --_fg: var(--c-text-main);
          --_accent_bg: var(--c-semantic-error-300);
          --_accent_fg: var(--c-semantic-error-700);
        `
      : $tone === 'warning'
        ? css`
            --_bg: var(--c-semantic-warning-100);
            --_fg: var(--c-text-main);
            --_accent_bg: var(--c-semantic-warning-300);
            --_accent_fg: var(--c-semantic-warning-700);
          `
        : $tone === 'info'
          ? css`
              --_bg: var(--c-semantic-info-100);
              --_fg: var(--c-text-main);
              --_accent_bg: var(--c-semantic-info-300);
              --_accent_fg: var(--c-semantic-info-700);
            `
          : $tone === 'success'
            ? css`
                --_bg: var(--c-semantic-success-100);
                --_fg: var(--c-text-main);
                --_accent_bg: var(--c-semantic-success-300);
                --_accent_fg: var(--c-semantic-success-700);
              `
            : undefined}
`;

export const Main = styled.div`
  font-size: var(--_text-size);
  line-height: var(--_text-line-height);
`;

export const CloseBtn = styled(ButtonReset)`
  position: relative;
  color: var(--_accent_fg);
  font-size: var(--_icon-size);
  margin-top: calc(
    (var(--_icon-size) - var(--_text-size) * var(--_text-line-height)) / -2
  ); // Vertically align to first line of text
  isolation: isolate;
  transform-origin: 50%;
  transition: transform 200ms ease;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${size(4)};
    height: ${size(4)};
    border-radius: 50%;
    background-color: var(--_accent_bg, var(--c-semantic-neutral-500));
    transform: translate(-50%, -50%);
    z-index: -1;
    opacity: 0;
    transition: opacity 150ms ease;
  }

  &:enabled {
    &:active {
      transform: scale(0.9);
    }

    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
`;
